import PropTypes from 'prop-types';
import {ORDER_TYPE} from '../pages/confirmation/utils/order-type';

export const PROPTYPE_CONFIRMATION_ORDER_TYPE = PropTypes.oneOf([
    ORDER_TYPE.AIRPORT,
    ORDER_TYPE.EVENT_PACKAGE,
    ORDER_TYPE.MONTHLY,
    ORDER_TYPE.TRANSIENT,
]);

export const PROPTYPE_CONFIRMATION_PAYMENT = PropTypes.shape({
    charge: PropTypes.shape({
        card: PropTypes.shape({
            brand: PropTypes.string,
            lastFour: PropTypes.string,
        }),
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        timestamp: PropTypes.string.isRequired,
    }),
    creditAmount: PropTypes.number,
    promocodeAmount: PropTypes.number,
});

export const PROPTYPE_CONFIRMATION_PRICE_BREAKDOWN = PropTypes.shape({
    currency: PropTypes.string.isRequired,
    totalPrice: PropTypes.number,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            price: PropTypes.number.isRequired,
            shortDescription: PropTypes.string.isRequired,
            fullDescription: PropTypes.string,
        })
    ).isRequired,
});

export const PROPTYPE_CONFIRMATION_RESERVATION = PropTypes.shape({
    id: PropTypes.number.isRequired,
    facility: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        timezone: PropTypes.string.isRequired,
        licensePlateRequired: PropTypes.bool.isRequired,
    }).isRequired,
    starts: PropTypes.string.isRequired,
    ends: PropTypes.string.isRequired,
    vehicle: PropTypes.shape({
        make: PropTypes.string,
        model: PropTypes.string,
        licensePlate: PropTypes.string,
    }),
    parkingPassUrl: PropTypes.string.isRequired,
});

export const PROPTYPE_CONFIRMATION_ORDER = PropTypes.shape({
    id: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            product: PropTypes.shape({
                title: PropTypes.string,
                description: PropTypes.string,
                id: PropTypes.number,
                type: PropTypes.string.isRequired,
                link: PropTypes.string,
            }).isRequired,
            reservations: PropTypes.arrayOf(
                PropTypes.shape({
                    PROPTYPE_CONFIRMATION_RESERVATION,
                })
            ).isRequired,
        })
    ).isRequired,
    payment: PropTypes.shape({
        PROPTYPE_CONFIRMATION_PAYMENT,
    }).isRequired,
    refund: {
        chargeAmount: PropTypes.number,
        creditAmount: PropTypes.number,
        promocodeAmount: PropTypes.number,
    },
    priceBreakdown: PropTypes.shape({
        PROPTYPE_CONFIRMATION_PRICE_BREAKDOWN,
    }).isRequired,
    driver: {
        id: PropTypes.number,
        email: PropTypes.string,
    },
});
